import { render } from "./ThresholdComparators.vue?vue&type=template&id=3d8e3c0c"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__